import React from 'react';
let SessionContext;
let { Provider } = (SessionContext = React.createContext())
export const useSession = () => React.useContext(SessionContext)
export default function Session(props) { 
    return <Provider value={props.value}>{props.children}</Provider>
}
